class PractitionerTestimonials extends HTMLElement {
  constructor() {
    super();
    this.swiperInstance = null;
    this.retryTimer = null;
    this.markupRetryTimer = null;
    this.boundRetry = this.init.bind(this);
    this.debugEnabled = false;
  }

  connectedCallback() {
    this.debugEnabled = this.dataset.debug === 'true' || window.location.search.includes('debugTestimonialSlider=1');
    this.log('connected');
    this.init();
  }

  disconnectedCallback() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
      this.swiperInstance = null;
    }

    if (this.retryTimer) {
      window.clearInterval(this.retryTimer);
      this.retryTimer = null;
    }

    if (this.markupRetryTimer) {
      window.clearInterval(this.markupRetryTimer);
      this.markupRetryTimer = null;
    }

    window.removeEventListener('load', this.boundRetry);
    this.log('disconnected');
  }

  init() {
    if (this.swiperInstance) {
      return;
    }

    const swiperElement = this.querySelector('[data-swiper]');
    if (!swiperElement) {
      this.warn('swiper container not found yet, waiting for markup...');
      this.waitForMarkup();
      return;
    }

    if (typeof Swiper === 'undefined') {
      this.warn('Swiper is not available yet, waiting...');
      this.waitForSwiper();
      return;
    }

    const prevButton = this.querySelector('[data-swiper-prev]');
    const nextButton = this.querySelector('[data-swiper-next]');
    const speed = parseInt(this.dataset.swiperSpeed, 10) || 500;

    this.swiperInstance = new Swiper(swiperElement, {
      slidesPerView: 1,
      loop: this.querySelectorAll('.amd-testimonial-slider__item').length > 1,
      speed,
      allowTouchMove: true,
      autoHeight: true,
      navigation: {
        prevEl: prevButton,
        nextEl: nextButton,
      },
      keyboard: {
        enabled: true,
      },
    });

    this.log('swiper initialized', {
      slides: this.querySelectorAll('.amd-testimonial-slider__item').length,
      speed,
      hasPrev: Boolean(prevButton),
      hasNext: Boolean(nextButton),
    });

    if (this.retryTimer) {
      window.clearInterval(this.retryTimer);
      this.retryTimer = null;
    }
  }

  waitForSwiper() {
    if (this.retryTimer) {
      return;
    }

    let attempts = 0;
    const maxAttempts = 40;

    this.retryTimer = window.setInterval(() => {
      attempts += 1;
      if (typeof Swiper !== 'undefined') {
        this.log(`Swiper detected after ${attempts} retries`);
        window.clearInterval(this.retryTimer);
        this.retryTimer = null;
        this.init();
        return;
      }

      if (attempts >= maxAttempts) {
        this.error('Swiper never became available');
        window.clearInterval(this.retryTimer);
        this.retryTimer = null;
      }
    }, 250);

    window.addEventListener('load', this.boundRetry, { once: true });
  }

  waitForMarkup() {
    if (this.markupRetryTimer) {
      return;
    }

    let attempts = 0;
    const maxAttempts = 40;

    this.markupRetryTimer = window.setInterval(() => {
      attempts += 1;
      const swiperElement = this.querySelector('[data-swiper]');

      if (swiperElement) {
        this.log(`Markup detected after ${attempts} retries`, {
          childCount: this.children.length,
        });
        window.clearInterval(this.markupRetryTimer);
        this.markupRetryTimer = null;
        this.init();
        return;
      }

      if (attempts >= maxAttempts) {
        this.error('swiper container not found after retries');
        window.clearInterval(this.markupRetryTimer);
        this.markupRetryTimer = null;
      }
    }, 100);
  }

  log(message, payload) {
    if (!this.debugEnabled) {
      return;
    }
    if (payload) {
      console.info('[PractitionerTestimonials]', message, payload);
      return;
    }
    console.info('[PractitionerTestimonials]', message);
  }

  warn(message) {
    if (!this.debugEnabled) {
      return;
    }
    console.warn('[PractitionerTestimonials]', message);
  }

  error(message) {
    console.error('[PractitionerTestimonials]', message);
  }
}

if (!customElements.get('practitioner-testimonials')) {
  customElements.define('practitioner-testimonials', PractitionerTestimonials);
}
